<template>
  <div class="mb-3 mt-1">
    <v-btn
      v-if="hasDocument && !sshcp"
      :href="docURL"
      target="_blank"
      color="menuActive"
      class="text-normal"
      depressed
      outlined
      rounded
      v-bind="$attrs"
    >
      {{ docName }}
      <v-icon class="ml-2">mdi-link</v-icon>
    </v-btn>
    <v-btn
      v-else-if="hasDocument && sshcp"
      @click="downloadFile()"
      color="menuActive"
      class="text-normal"
      depressed
      outlined
      rounded
      :loading="downloading"
      v-bind="$attrs"
    >
      {{ docName }}
      <v-icon class="ml-2">mdi-link</v-icon>
    </v-btn>
    <v-chip class="fs-14" v-else>Not Available</v-chip>
  </div>
</template>

<script>
export default {
  name: 'supporting-document-link',
  props: {
    detail: {},
    name: {},
    sshcp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      downloading: false
    };
  },
  computed: {
    hasDocument() {
      return this.docURL && this.docName;
    },
    document() {
      return this.detail ? this.detail.document : {};
    },
    docURL() {
      if (this.sshcp) {
        return this.detail.s3_url;
      } else {
        return this.document[`${this.name}_url`];
      }
    },
    docID() {
      if (this.sshcp) {
        return this.detail.id;
      } else {
        return null;
      }
    },
    docName() {
      if (this.sshcp) {
        return this.detail.file_name_origin || this.detail.name;
      } else {
        return this.document[`${this.name}_name`];
      }
    }
  },
  methods: {
    async downloadFile() {
      this.downloading = true;
      const res = await this.$store.dispatch(
        'sshcp/downloadSuppDocs',
        this.docID
      );
      this.downloading = false;
      window.open(res.data.url, '_blank');
    }
  }
};
</script>
